<template>
    <div id="pricing_calculator">
        <Calculator></Calculator>
    </div>
</template>

<script>

    import Tiers from './components/Tiers'
    import Calculator from './components/Calculator'
    import commonMixins from '../../common/mixins/common'


    export default {
        name: 'pricing-calculator',
        components: {Calculator, Tiers},
        mixins: [commonMixins],
        data(){
            return{
                calc: "Citrix Secure Workspace"
            }
        },
        created(){
            this.consoleLog(`loaded [version ${process.env.VUE_APP_VERSION}]`)

            this.languageCheck()
        }
    }


</script>

<style lang="scss">

    @import "../../common/css/_global";
    @import "../../common/css/styles";

</style>